var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.event && _vm.event.status != 2 && !_vm.ticket.valid && !_vm.ticket.error && !_vm.ticket.winner && (typeof _vm.ticket.valid !== 'undefined'))?_c('button',{staticClass:"btn btn-fill btn-icon btn-danger",attrs:{"title":"Informar erro"},on:{"click":function($event){return _vm.onClick()}}},[_c('i',{staticClass:"ti-close"})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a1c5a30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Tickets/Actions/TicketInvalidateError.vue
// module id = 7X6m
// module chunks = 10